const ONE_SCHEMA_DATE_PATTERN = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

export type OneSchemaDate =
	| { status: 'blank' }
	| { status: 'invalid' }
	| { status: 'valid'; date: Date };

export const parseOneSchemaDate = (value?: string | null): OneSchemaDate => {
	const trimmed = value?.trim();
	if (!trimmed) {
		return { status: 'blank' };
	}

	const match = trimmed.match(ONE_SCHEMA_DATE_PATTERN);
	if (!match) {
		return { status: 'invalid' };
	}

	const day = Number(match[1]);
	const month = Number(match[2]);
	const year = Number(match[3]);
	const date = new Date(Date.UTC(year, month - 1, day));

	const isRealDate =
		date.getUTCFullYear() === year &&
		date.getUTCMonth() === month - 1 &&
		date.getUTCDate() === day;

	return isRealDate ? { status: 'valid', date } : { status: 'invalid' };
};
